(function () {
  const root = document.querySelector('.product-reviews');
  if (!root) return;

  const productGid = root.dataset.productGid;
  const customerId = root.dataset.customerId;
  const customerName = root.dataset.customerName;
  const canReview = root.dataset.customerCanReview === 'true';
  const isLoggedIn = root.dataset.customerLoggedIn === 'true';
  const signinUrl = root.dataset.signinUrl;

  const topbarEl = root.querySelector('[data-topbar]');
  const topbarLeft = topbarEl.querySelector('.product-reviews__topbar-left');
  const searchWrap = root.querySelector('[data-search-wrap]');
  const searchInput = root.querySelector('[data-search]');
  const writeCtaEl = root.querySelector('[data-write-cta]');
  const summaryGrid = root.querySelector('[data-summary-grid]');
  const snapshotEl = root.querySelector('[data-snapshot]');
  const photosStripEl = root.querySelector('[data-photos-strip]');
  const controlsEl = root.querySelector('[data-controls]');
  const resultCountEl = root.querySelector('[data-result-count]');
  const sortEl = root.querySelector('[data-sort]');
  const listEl = root.querySelector('[data-list]');
  const pagerEl = root.querySelector('[data-pager]');
  const statusEl = root.querySelector('[data-status]');

  const state = {
    reviews: [],
    count: 0,
    average: 0,
    distribution: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
    aggregates: { quality: null, value: null, ease: null, recommend_pct: null, recommend_votes: 0 },
    yourReviewStatus: null,
    starFilter: null,
    searchQuery: '',
    sort: 'newest',
    page: 1,
    pageSize: 8,
  };

  /* === Helpers === */
  const escapeHtml = (s) => {
    const d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  };

  const STAR_PATH = 'M12 2.6l2.92 5.92 6.53.95-4.72 4.6 1.11 6.5L12 17.5l-5.84 3.07 1.11-6.5-4.72-4.6 6.53-.95L12 2.6z';
  const STAR_SVG = `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${STAR_PATH}"/></svg>`;
  const STAR_ROW = STAR_SVG.repeat(5);

  /* Five stars with precise fractional fill (value 0–5) */
  const starsSvg = (value, cls) => {
    const v = Math.max(0, Math.min(5, Number(value) || 0));
    const pct = (v / 5) * 100;
    return `<span class="pr-stars${cls ? ' ' + cls : ''}" role="img" aria-label="${(Math.round(v * 10) / 10)} out of 5 stars">
      <span class="pr-stars__bg">${STAR_ROW}</span>
      <span class="pr-stars__fg" style="width:${pct.toFixed(1)}%">${STAR_ROW}</span>
    </span>`;
  };

  const timeAgo = (iso) => {
    if (!iso) return '';
    const then = new Date(iso);
    if (isNaN(then)) return '';
    const diffMs = Date.now() - then.getTime();
    const days = Math.floor(diffMs / 86400000);
    if (days < 1) return 'today';
    if (days === 1) return 'yesterday';
    if (days < 7) return `${days} days ago`;
    if (days < 30) {
      const w = Math.floor(days / 7);
      return `${w} week${w === 1 ? '' : 's'} ago`;
    }
    if (days < 365) {
      const m = Math.floor(days / 30);
      return `${m} month${m === 1 ? '' : 's'} ago`;
    }
    const y = Math.floor(days / 365);
    return `${y} year${y === 1 ? '' : 's'} ago`;
  };

  const avatarColor = (name) => {
    const palette = ['var(--pr-avatar-1)','var(--pr-avatar-2)','var(--pr-avatar-3)','var(--pr-avatar-4)','var(--pr-avatar-5)','var(--pr-avatar-6)'];
    let hash = 0;
    for (let i = 0; i < (name || 'A').length; i++) {
      hash = ((hash << 5) - hash) + (name || 'A').charCodeAt(i);
      hash |= 0;
    }
    return palette[Math.abs(hash) % palette.length];
  };

  const initials = (name) => {
    if (!name) return '?';
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0][0] || '?';
    return (parts[0][0] || '') + (parts[parts.length - 1][0] || '');
  };

  const cssEscape = (s) => String(s).replace(/[^a-zA-Z0-9_-]/g, c => '\\' + c);

  /* === SVG icons === */
  const ICON_CHECK = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>`;
  const ICON_HEART = `<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>`;
  const ICON_PENCIL = `<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>`;
  const ICON_UPLOAD = `<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>`;

  /* === Summary hero (big average) === */
  function renderTopbar() {
    if (state.count === 0) {
      topbarLeft.innerHTML = '';
      return;
    }
    topbarLeft.innerHTML = `
      <div class="product-reviews__avg-num">${state.average.toFixed(1)}</div>
      <div class="product-reviews__avg-detail">
        ${starsSvg(state.average, 'pr-stars--lg')}
        <span class="product-reviews__avg-count">Based on ${state.count} review${state.count === 1 ? '' : 's'}</span>
      </div>
    `;
  }

  /* === Write CTA === */
  function renderWriteCta() {
    if (!isLoggedIn) {
      writeCtaEl.innerHTML = `<a class="product-reviews__write-btn" href="${escapeHtml(signinUrl)}">${ICON_PENCIL} Sign in to write a review</a>`;
      return;
    }
    if (canReview) {
      // Check ALL of customer's reviews (including pending/rejected), not just approved
      const status = state.yourReviewStatus;
      if (status === 'approved') {
        writeCtaEl.innerHTML = `<button class="product-reviews__write-btn" disabled>${ICON_CHECK} You've reviewed this</button>`;
      } else if (status === 'pending') {
        writeCtaEl.innerHTML = `<button class="product-reviews__write-btn" disabled>⏳ Your review is awaiting approval</button>`;
      } else if (status === 'rejected') {
        writeCtaEl.innerHTML = `<button class="product-reviews__write-btn" disabled>Review not approved</button>`;
      } else {
        writeCtaEl.innerHTML = `<button class="product-reviews__write-btn" data-open-modal>${ICON_PENCIL} Write a review</button>`;
        writeCtaEl.querySelector('[data-open-modal]').addEventListener('click', openModal);
      }
    } else {
      writeCtaEl.innerHTML = `<button class="product-reviews__write-btn" disabled>Buy this to leave a review</button>`;
    }
  }

  /* === Rating Snapshot (clickable distribution bars) === */
  function renderSnapshot() {
    const total = state.count;
    let html = '';
    for (let star = 5; star >= 1; star--) {
      const c = state.distribution[star] || 0;
      const pct = total > 0 ? (c / total) * 100 : 0;
      const isActive = state.starFilter === star;
      html += `
        <button class="product-reviews__snap-row ${isActive ? 'active' : ''}" data-snap-star="${star}" aria-label="Filter by ${star} stars" aria-pressed="${isActive}">
          <span class="product-reviews__snap-label">${star}<span class="product-reviews__snap-star">${STAR_SVG}</span></span>
          <div class="product-reviews__snap-bar"><div class="product-reviews__snap-fill" style="width:0%" data-target-w="${pct.toFixed(1)}"></div></div>
          <span class="product-reviews__snap-count">${c}</span>
        </button>
      `;
    }
    snapshotEl.innerHTML = `<div class="product-reviews__snapshot">${html}</div>`;
    snapshotEl.querySelectorAll('[data-snap-star]').forEach(btn => {
      btn.addEventListener('click', () => {
        const star = parseInt(btn.dataset.snapStar, 10);
        state.starFilter = state.starFilter === star ? null : star;
        state.page = 1;
        renderSnapshot();
        renderList();
        animateBars();
      });
    });
    requestAnimationFrame(animateBars);
  }

  function animateBars() {
    root.querySelectorAll('[data-target-w]').forEach(bar => {
      bar.style.width = bar.dataset.targetW + '%';
    });
  }

  /* === Photos strip === */
  function renderPhotosStrip() {
    const allPhotos = [];
    state.reviews.forEach(r => (r.images || []).forEach(url => allPhotos.push(url)));
    if (allPhotos.length === 0) { photosStripEl.hidden = true; return; }
    photosStripEl.hidden = false;
    const slice = allPhotos.slice(0, 8);
    photosStripEl.innerHTML = `
      <span class="product-reviews__photos-strip-label">Customer Photos</span>
      ${slice.map((url, i) => `<img class="product-reviews__strip-thumb" data-strip-i="${i}" src="${escapeHtml(url)}" alt="Customer photo" loading="lazy">`).join('')}
    `;
    photosStripEl.querySelectorAll('[data-strip-i]').forEach((el, i) => {
      el.addEventListener('click', () => openLightbox(slice, i));
    });
  }

  /* === Filter + sort + search === */
  function applyFilters() {
    let r = [...state.reviews];
    if (state.starFilter !== null) r = r.filter(x => x.rating === state.starFilter);
    if (state.searchQuery) {
      const q = state.searchQuery.toLowerCase();
      r = r.filter(x =>
        (x.title || '').toLowerCase().includes(q) ||
        (x.body || '').toLowerCase().includes(q)
      );
    }
    const cmp = {
      newest: (a, b) => (b.created_at || '').localeCompare(a.created_at || ''),
      oldest: (a, b) => (a.created_at || '').localeCompare(b.created_at || ''),
      highest: (a, b) => b.rating - a.rating,
      lowest: (a, b) => a.rating - b.rating,
      helpful: (a, b) => (b.helpful_count || 0) - (a.helpful_count || 0),
    };
    r.sort(cmp[state.sort] || cmp.newest);
    return r;
  }

  /* === Review card === */
  function renderCard(r, index) {
    const photos = (r.images || []).map((url, i) => `
      <div class="product-reviews__photo-thumb" data-thumb data-index="${i}">
        <img src="${escapeHtml(url)}" alt="Customer photo" loading="lazy">
      </div>
    `).join('');

    const avatarBg = avatarColor(r.customer_name);
    const initial = escapeHtml(initials(r.customer_name));
    const ago = timeAgo(r.created_at);
    const helpfulCount = r.helpful_count || 0;

    const metaItems = [];
    if (r.location) {
      metaItems.push(`<div class="product-reviews__author-location">${escapeHtml(r.location)}</div>`);
    }

    return `
      <article class="product-reviews__card" data-card-id="${escapeHtml(r.id)}" style="--pr-i:${index || 0};">
        <div class="product-reviews__card-meta">
          <div class="product-reviews__avatar" style="background:${avatarBg};">${initial}</div>
          <div class="product-reviews__author-block">
            <div class="product-reviews__author-name">${escapeHtml(r.customer_name)}</div>
            ${metaItems.join('')}
          </div>
        </div>
        <div class="product-reviews__card-main">
          <div class="product-reviews__card-header">
            ${starsSvg(r.rating)}
            <span class="product-reviews__card-ago">${ago}</span>
            ${r.verified_purchase ? `<span class="product-reviews__verified">${ICON_CHECK} Verified buyer</span>` : ''}
          </div>
          ${r.title ? `<h4 class="product-reviews__card-title">${escapeHtml(r.title)}</h4>` : ''}
          <p class="product-reviews__card-body">${escapeHtml(r.body)}</p>
          ${photos ? `<div class="product-reviews__card-photos">${photos}</div>` : ''}
          <div class="product-reviews__card-footer">
            <button class="product-reviews__helpful" data-helpful>
              ${ICON_HEART}
              <span data-helpful-label>Helpful${helpfulCount > 0 ? ` · ${helpfulCount}` : ''}</span>
            </button>
          </div>
        </div>
      </article>
    `;
  }

  function renderList() {
    const filtered = applyFilters();
    const totalPages = Math.max(1, Math.ceil(filtered.length / state.pageSize));
    if (state.page > totalPages) state.page = totalPages;
    const start = (state.page - 1) * state.pageSize;
    const end = Math.min(start + state.pageSize, filtered.length);
    const slice = filtered.slice(start, end);

    // Result count
    if (state.count > 0) {
      if (filtered.length === 0) {
        resultCountEl.textContent = 'No matching reviews';
      } else {
        resultCountEl.textContent = `Showing ${start + 1}–${end} of ${filtered.length} review${filtered.length === 1 ? '' : 's'}`;
      }
    } else {
      resultCountEl.textContent = '';
    }

    if (slice.length === 0) {
      if (state.count === 0) {
        listEl.innerHTML = '';
      } else {
        listEl.innerHTML = `
          <div class="product-reviews__empty">
            <p class="product-reviews__empty-title">No reviews match your search</p>
            <p class="product-reviews__empty-sub">Try a different keyword or clear the star filter.</p>
          </div>
        `;
      }
    } else {
      listEl.innerHTML = slice.map((r, i) => renderCard(r, i)).join('');
    }

    slice.forEach(r => {
      const card = listEl.querySelector(`[data-card-id="${cssEscape(r.id)}"]`);
      if (!card) return;
      const btn = card.querySelector('[data-helpful]');
      if (btn) {
        if (localStorage.getItem(`lumi_review_voted_${r.id}`)) {
          btn.classList.add('voted');
          btn.disabled = true;
        }
        btn.addEventListener('click', () => voteHelpful(r.id, btn));
      }
      card.querySelectorAll('[data-thumb]').forEach((thumb, idx) => {
        thumb.addEventListener('click', () => openLightbox(r.images, idx));
      });
    });

    renderPager(totalPages);
    requestAnimationFrame(animateBars);
  }

  function renderPager(totalPages) {
    if (totalPages <= 1) { pagerEl.hidden = true; pagerEl.innerHTML = ''; return; }
    pagerEl.hidden = false;
    const cur = state.page;
    const pages = [];
    pages.push(1);
    if (cur > 3) pages.push('…');
    for (let p = Math.max(2, cur - 1); p <= Math.min(totalPages - 1, cur + 1); p++) {
      pages.push(p);
    }
    if (cur < totalPages - 2) pages.push('…');
    if (totalPages > 1) pages.push(totalPages);

    let html = `<button class="product-reviews__page-btn" data-page="prev" ${cur === 1 ? 'disabled' : ''} aria-label="Previous page">←</button>`;
    pages.forEach(p => {
      if (p === '…') {
        html += `<span class="product-reviews__pager-ellipsis">…</span>`;
      } else {
        html += `<button class="product-reviews__page-btn ${p === cur ? 'active' : ''}" data-page="${p}">${p}</button>`;
      }
    });
    html += `<button class="product-reviews__page-btn" data-page="next" ${cur === totalPages ? 'disabled' : ''} aria-label="Next page">→</button>`;
    pagerEl.innerHTML = html;

    pagerEl.querySelectorAll('[data-page]').forEach(btn => {
      btn.addEventListener('click', () => {
        const v = btn.dataset.page;
        if (v === 'prev') state.page--;
        else if (v === 'next') state.page++;
        else state.page = parseInt(v, 10);
        renderList();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  async function voteHelpful(reviewId, btn) {
    if (btn.classList.contains('voted')) return;
    btn.classList.add('voted');
    btn.disabled = true;
    const label = btn.querySelector('[data-helpful-label]');
    const m = label.textContent.match(/(\d+)/);
    const current = m ? parseInt(m[1], 10) : 0;
    label.textContent = `Helpful · ${current + 1}`;
    localStorage.setItem(`lumi_review_voted_${reviewId}`, '1');
    try {
      await fetch('/apps/reviews/helpful', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ review_id: reviewId }),
      });
    } catch (e) {
      console.error('Helpful vote failed:', e);
    }
  }

  /* === Search === */
  let searchDebounce = null;
  searchInput?.addEventListener('input', () => {
    clearTimeout(searchDebounce);
    searchDebounce = setTimeout(() => {
      state.searchQuery = searchInput.value.trim();
      state.page = 1;
      renderList();
    }, 200);
  });

  sortEl?.addEventListener('change', () => {
    state.sort = sortEl.value;
    state.page = 1;
    renderList();
  });

  /* Buy-panel rating row (PDP hero) — fed from the same review data */
  function renderBuyPanelSummary() {
    document.querySelectorAll('[data-pdp-reviews-summary]').forEach(el => {
      if (state.count > 0) {
        el.innerHTML = `
          ${starsSvg(state.average)}
          <span class="pdp-buy__rating-text"><strong>${state.average.toFixed(1)}</strong> · ${state.count} review${state.count === 1 ? '' : 's'}</span>
        `;
      } else {
        el.innerHTML = `<span class="pdp-buy__rating-text">Be the first to review</span>`;
      }
      el.hidden = false;
      if (!el.dataset.bound) {
        el.dataset.bound = '1';
        el.addEventListener('click', (e) => {
          e.preventDefault();
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    });
  }

  function render() {
    renderTopbar();
    renderWriteCta();
    renderBuyPanelSummary();
    if (state.count > 0) {
      if (statusEl) { statusEl.hidden = true; statusEl.innerHTML = ''; }
      summaryGrid.hidden = false;
      searchWrap.hidden = false;
      controlsEl.hidden = false;
      renderSnapshot();
      renderPhotosStrip();
    } else {
      summaryGrid.hidden = true;
      searchWrap.hidden = true;
      controlsEl.hidden = true;
      photosStripEl.hidden = true;
      if (statusEl) {
        statusEl.hidden = false;
        statusEl.innerHTML = `
          <div class="product-reviews__empty product-reviews__empty--first">
            <span class="product-reviews__empty-mark" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
            </span>
            <p class="product-reviews__empty-title">No reviews yet</p>
            <p class="product-reviews__empty-sub">Tried this with your pet? Be the first to share how it went.</p>
          </div>
        `;
      }
    }
    renderList();
  }

  async function loadReviews() {
    try {
      const res = await fetch(`/apps/reviews?product_id=${encodeURIComponent(productGid)}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      state.reviews = data.reviews || [];
      state.count = data.count || 0;
      state.average = data.average_rating || 0;
      state.distribution = data.distribution || { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
      state.aggregates = data.aggregates || { quality: null, value: null, ease: null, recommend_pct: null, recommend_votes: 0 };
      state.yourReviewStatus = data.your_review_status || null;

      // Update JSON-LD
      const jsonld = document.querySelector('[data-reviews-jsonld]');
      if (jsonld && state.count > 0) {
        try {
          const obj = JSON.parse(jsonld.textContent);
          obj.aggregateRating = { '@type': 'AggregateRating', ratingValue: state.average, reviewCount: state.count };
          jsonld.textContent = JSON.stringify(obj);
        } catch (e) {}
      }

      render();
    } catch (err) {
      if (statusEl) {
        statusEl.hidden = false;
        statusEl.innerHTML = `
          <div class="product-reviews__empty">
            <p class="product-reviews__empty-title">Reviews could not be loaded</p>
            <p class="product-reviews__empty-sub">Please refresh the page to try again.</p>
          </div>
        `;
      }
      console.error(err);
    }
  }

  /* === Lightbox === */
  function openLightbox(images, startIndex) {
    if (!images || images.length === 0) return;
    let idx = startIndex || 0;

    const lb = document.createElement('div');
    lb.className = 'product-reviews__lightbox';
    lb.innerHTML = `
      <div class="product-reviews__lightbox-counter" data-counter></div>
      <button class="product-reviews__lightbox-close" aria-label="Close">×</button>
      ${images.length > 1 ? '<button class="product-reviews__lightbox-prev" aria-label="Previous">‹</button>' : ''}
      <div class="product-reviews__lightbox-content">
        <img alt="Customer photo">
      </div>
      ${images.length > 1 ? '<button class="product-reviews__lightbox-next" aria-label="Next">›</button>' : ''}
    `;
    document.body.appendChild(lb);
    document.body.style.overflow = 'hidden';

    const img = lb.querySelector('img');
    const counter = lb.querySelector('[data-counter]');
    img.style.transition = 'opacity 0.15s ease';

    const show = (i) => {
      idx = (i + images.length) % images.length;
      img.style.opacity = '0';
      const next = new Image();
      next.onload = () => { img.src = images[idx]; img.style.opacity = '1'; };
      next.src = images[idx];
      counter.textContent = `${idx + 1} / ${images.length}`;
    };
    show(idx);

    const close = () => {
      lb.remove();
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
    };
    const onKey = (e) => {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft' && images.length > 1) show(idx - 1);
      else if (e.key === 'ArrowRight' && images.length > 1) show(idx + 1);
    };
    document.addEventListener('keydown', onKey);

    lb.querySelector('.product-reviews__lightbox-close').addEventListener('click', close);
    lb.querySelector('.product-reviews__lightbox-prev')?.addEventListener('click', () => show(idx - 1));
    lb.querySelector('.product-reviews__lightbox-next')?.addEventListener('click', () => show(idx + 1));
    lb.addEventListener('click', (e) => {
      if (e.target === lb || e.target.classList.contains('product-reviews__lightbox-content')) close();
    });
  }

  /* === Modal === */
  function openModal() {
    const backdrop = document.createElement('div');
    backdrop.className = 'product-reviews__modal-backdrop';
    backdrop.innerHTML = `
      <div class="product-reviews__modal" role="dialog" aria-labelledby="pr-modal-title">
        <button class="product-reviews__modal-close" aria-label="Close">×</button>
        <h3 id="pr-modal-title">Write a Review</h3>
        <form data-review-form novalidate>
          <div class="product-reviews__form-row">
            <label>Overall rating</label>
            <div class="product-reviews__star-picker" data-star-picker>
              ${[1,2,3,4,5].map(i => `<button type="button" data-star="${i}" aria-label="${i} star${i > 1 ? 's' : ''}">★</button>`).join('')}
            </div>
            <input type="hidden" name="rating" required>
          </div>

          <div class="product-reviews__form-row">
            <label for="pr-title">Title <span class="pr-optional">(optional)</span></label>
            <input type="text" id="pr-title" name="title" maxlength="120" placeholder="Sum it up in a few words">
          </div>

          <div class="product-reviews__form-row">
            <label for="pr-body">Your review</label>
            <textarea id="pr-body" name="body" rows="5" required maxlength="2000" placeholder="What did you love? What could be better?"></textarea>
            <div class="product-reviews__char-count" data-char-count>0 / 2000</div>
          </div>

          <div class="product-reviews__form-row">
            <label>Add photos <span class="pr-optional">(optional, max 3)</span></label>
            <div class="product-reviews__dropzone" data-dropzone>
              <span class="product-reviews__dropzone-icon">${ICON_UPLOAD}</span>
              <span class="product-reviews__dropzone-text">Drop photos here or click to browse</span>
              <span class="product-reviews__dropzone-hint">JPG, PNG, WebP — max 5MB each</span>
              <input type="file" accept="image/jpeg,image/png,image/webp" multiple hidden data-file-input>
            </div>
            <div class="product-reviews__previews" data-previews></div>
          </div>

          <button type="submit" class="product-reviews__submit">Submit Review</button>
          <p class="product-reviews__form-message" data-form-message></p>
        </form>
      </div>
    `;
    document.body.appendChild(backdrop);
    document.body.style.overflow = 'hidden';
    initForm(backdrop);

    const close = () => {
      backdrop.remove();
      document.body.style.overflow = '';
    };
    backdrop.addEventListener('click', (e) => { if (e.target === backdrop) close(); });
    backdrop.querySelector('.product-reviews__modal-close').addEventListener('click', close);
    const onKey = (e) => {
      if (e.key === 'Escape') { close(); document.removeEventListener('keydown', onKey); }
    };
    document.addEventListener('keydown', onKey);
  }

  function initForm(backdrop) {
    const form = backdrop.querySelector('[data-review-form]');
    const ratingInput = form.querySelector('input[name="rating"]');
    const picker = form.querySelector('[data-star-picker]');
    const titleInput = form.querySelector('input[name="title"]');
    const bodyArea = form.querySelector('textarea[name="body"]');
    const charCount = form.querySelector('[data-char-count]');
    const dropzone = form.querySelector('[data-dropzone]');
    const fileInput = form.querySelector('[data-file-input]');
    const previews = form.querySelector('[data-previews]');
    const message = form.querySelector('[data-form-message]');
    const submitBtn = form.querySelector('button[type="submit"]');

    let selectedFiles = [];
    let selectedRating = 0;

    /* Overall star picker with hover */
    const updateStars = (hoverIdx) => {
      const show = hoverIdx != null ? hoverIdx : selectedRating;
      picker.querySelectorAll('button').forEach((bb, j) => {
        bb.classList.toggle('active', j < show);
        bb.classList.toggle('preview', hoverIdx != null && j < hoverIdx && hoverIdx > selectedRating);
      });
      picker.classList.toggle('hover-state', hoverIdx != null);
    };

    picker.querySelectorAll('button').forEach((b, i) => {
      b.addEventListener('click', () => {
        selectedRating = i + 1;
        ratingInput.value = selectedRating;
        updateStars();
      });
      b.addEventListener('mouseenter', () => updateStars(i + 1));
    });
    picker.addEventListener('mouseleave', () => updateStars());

    /* Char counter */
    bodyArea.addEventListener('input', () => {
      charCount.textContent = `${bodyArea.value.length} / 2000`;
    });

    /* Files */
    const renderPreviews = () => {
      previews.innerHTML = selectedFiles.map((file, i) => `
        <div class="product-reviews__preview">
          <img src="${URL.createObjectURL(file)}" alt="">
          <button type="button" class="product-reviews__preview-remove" data-remove="${i}" aria-label="Remove">×</button>
        </div>
      `).join('');
      previews.querySelectorAll('[data-remove]').forEach(btn => {
        btn.addEventListener('click', () => {
          selectedFiles.splice(parseInt(btn.dataset.remove, 10), 1);
          renderPreviews();
        });
      });
    };

    const acceptFiles = (files) => {
      const arr = Array.from(files);
      const next = [...selectedFiles, ...arr].slice(0, 3);
      const valid = next.filter(f =>
        ['image/jpeg', 'image/png', 'image/webp'].includes(f.type) && f.size <= 5 * 1024 * 1024
      );
      if (valid.length < next.length) {
        message.textContent = 'Some files were rejected (max 5MB, JPG/PNG/WebP only).';
        message.className = 'product-reviews__form-message error';
      } else {
        message.textContent = '';
        message.className = 'product-reviews__form-message';
      }
      selectedFiles = valid;
      renderPreviews();
    };

    dropzone.addEventListener('click', () => fileInput.click());
    fileInput.addEventListener('change', (e) => acceptFiles(e.target.files));
    dropzone.addEventListener('dragover', (e) => { e.preventDefault(); dropzone.classList.add('dragging'); });
    dropzone.addEventListener('dragleave', () => dropzone.classList.remove('dragging'));
    dropzone.addEventListener('drop', (e) => {
      e.preventDefault();
      dropzone.classList.remove('dragging');
      acceptFiles(e.dataTransfer.files);
    });

    /* Submit */
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      message.textContent = '';
      message.className = 'product-reviews__form-message';

      const rating = parseInt(ratingInput.value, 10);
      const title = titleInput.value.trim();
      const body = bodyArea.value.trim();

      if (!rating || rating < 1 || rating > 5) {
        message.textContent = 'Please select an overall rating.';
        message.classList.add('error');
        return;
      }
      if (!body) {
        message.textContent = 'Please write your review.';
        message.classList.add('error');
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = selectedFiles.length > 0 ? 'Uploading photos…' : 'Submitting…';

      try {
        let resourceUrls = [];
        if (selectedFiles.length > 0) {
          const initRes = await fetch('/apps/reviews/upload-init', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              files: selectedFiles.map(f => ({ filename: f.name, size: f.size, mimeType: f.type })),
            }),
          });
          if (!initRes.ok) {
            const j = await initRes.json();
            throw new Error(j.error || 'Upload init failed');
          }
          const initData = await initRes.json();
          const targets = initData.staged_targets;
          for (let i = 0; i < selectedFiles.length; i++) {
            const t = targets[i];
            const fd = new FormData();
            for (const p of t.parameters) fd.append(p.name, p.value);
            fd.append('file', selectedFiles[i]);
            const up = await fetch(t.url, { method: 'POST', body: fd });
            if (!up.ok) throw new Error('Photo upload failed');
            resourceUrls.push(t.resourceUrl);
          }
        }

        submitBtn.textContent = 'Submitting…';
        const payload = {
          product_id: productGid,
          customer_name: customerName,
          rating,
          title,
          body,
          image_resource_urls: resourceUrls,
        };

        const submitRes = await fetch('/apps/reviews/submit', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        const data = await submitRes.json();
        if (submitRes.ok && data.success) {
          message.textContent = '🎉 Thank you! Your review is awaiting approval.';
          message.classList.add('success');
          setTimeout(() => {
            document.querySelector('.product-reviews__modal-backdrop')?.remove();
            document.body.style.overflow = '';
          }, 1800);
        } else {
          message.textContent = data.error || 'Submission failed.';
          message.classList.add('error');
        }
      } catch (err) {
        message.textContent = err.message || 'Network error.';
        message.classList.add('error');
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Submit Review';
      }
    });
  }

  loadReviews();
})();
